'use client';

import React from 'react';

import { Button } from '@/components/button/Button';
import { useTranslations } from '@/lib/locale-context';

type Props = {
  onClose: () => void;
};

const ErrorState: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslations();
  const title = t('gatewayForms.error.title');
  const description = t('gatewayForms.error.description');
  const closeLabel = t('gatewayForms.success.close');

  return (
    <div className="mx-auto flex w-full max-w-md flex-col items-center px-4 text-center sm:px-6">
      <div className="mb-5 flex h-[52px] w-[52px] items-center justify-center rounded-full bg-[#EF4444]">
        <span
          className="text-[30px] font-semibold leading-none text-white"
          aria-hidden="true"
        >
          !
        </span>
      </div>

      <h2 className="text-[28px] font-medium leading-tight text-[#1A1B25] sm:text-[32px]">
        {title}
      </h2>

      <p className="mt-3 max-w-[32rem] text-[14px] leading-6 text-[#666D80]">
        {description}
      </p>

      <Button
        variant="primary"
        name={closeLabel}
        className="mt-6 w-full justify-center sm:w-fit"
        onClick={onClose}
      >
        {closeLabel}
      </Button>
    </div>
  );
};

export default ErrorState;
